module.exports = __webpack_public_path__ + "src/img/designer.4794eb7c07b818c3fd708ee290702956.png";